import React, { useState } from "react";
import Popups from "../Modals/Popups";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";

export default function SpCta() {
  const [show, setShow] = useState(false);
  return (
    <div className="px-6 my-5">
      {" "}
      <div className=" spCta-video-container">
        <video
          width="100%"
          controls={false}
          loop
          autoPlay
          muted
          playsInline
          className="spCta-video"
        >
          <source src="/images/SpCtaBg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="spCta-overlay-text px-6 py-3">
          <p>Got an idea?</p>
          <h2>
            Let’s build your ERP project live. <br /> Share it with us!
          </h2>
          <button onClick={() => setShow(true)}>Schedule a Consultation</button>
        </div>
      </div>
      <Popups show={show} setShow={setShow} title="Let's Talk" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </div>
  );
}
